import { AppStatus } from "@utils/constants";
import { getTailwindColorFromAppStatus } from "@utils/getTailwindColorFromAppStatus";

const AppStatusChip = ({ status }: { status?: AppStatus }) => {
  if (!status) return null;

  const { borderColor, textColor, backgroundColor } = getTailwindColorFromAppStatus(status);
  return (
    <div className={`select-none border border-x-2 ${borderColor} px-1.5 py-0.5 flex items-center justify-center rounded-full ${backgroundColor}`}>
      <p className={`${textColor} uppercase text-xs font-semibold`}>{status}</p>
    </div>
  );
};

export default AppStatusChip;
